import { Bar } from 'react-chartjs-2';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  colors
} from '@mui/material';
import BasicMenu from 'src/components/common/BasicMenu';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from "prop-types";
import PerfectScrollbar from 'react-perfect-scrollbar';

const RequestChart = ({ refreshBarChart, ...props }) => {
  const theme = useTheme();
  const MenuList = [{
    id: 7,
    title: 'Last 7 days'
  }, {
    id: 10,
    title: 'Last 10 days'
  }, {
    id: 14,
    title: 'Last 14 days'
  }, {
    id: 30,
    title: 'Last 30 days'
  }]
  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true, //default
        labels: {
          boxWidth: 25
        }

      }
    },
    scales: {
      x: {
        // barThickness: 12,
        // maxBarThickness: 10,
        // barPercentage: 0.5,
        // categoryPercentage: 0.5,
        ticks: {
          fontColor: theme.palette.text.secondary,
        },
        grid: {
          display: false
        }
      }
      ,
      y: [
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          }
        }
      ]
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  return (
    <Card {...props}
      elevation={0}>
      {props.isHeaderRequired ?
        <CardHeader
          action={(
            <BasicMenu shadow={true} default={MenuList[MenuList.length - 1]} list={MenuList} onMenuSelect={(value) => refreshBarChart(value)} />
          )}
          title="Day-wise Delivered Orders"
        /> : null
      }

      <CardContent>
        <PerfectScrollbar>
          <Box
            sx={{
              height: 350,
              width: `calc(${props.data && props.data.labels && props.data.labels.length > 14 ? props.data["labels"].length / 1.5 : 10}*70px)`,
              position: 'relative'
            }}
            className={!props.data ? 'display-center' : ''}
          >{console.log(props.data)}
            {props.data ? <Bar
              data={props.data}
              options={options}
            /> : <CircularProgress disableShrink size={60} />}
          </Box>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

RequestChart.propTypes = {
  refreshBarChart: PropTypes.func,
  data: PropTypes.object
};

export default RequestChart;
